import { isSet } from '../utils/isSet';
import { loadResourceFile } from '../functions/loadResourceFile';

class YoutubeEmbed {
    constructor (domNode) {
        this.domNode = domNode;
        this.videoId = domNode.dataset.videoId;
        this.poster = domNode.querySelector('.embed__poster');
        this.target = domNode.querySelector('.embed__target');
        this.play = domNode.querySelector('.embed__play');
        this.apiUrl = 'https://www.youtube.com/iframe_api';

        if(isSet(this.play)) this.play.addEventListener('click', this.onPlayClick.bind(this));

        this.init();
    }

    init(){
        this.domNode.id =  this.util__uniqid('youtube-embed-container-' + this.videoId, true);
        this.target.id = this.util__uniqid('youtube-embed-player-' + this.videoId, true);

        this.loadPlayerScript();
    }

    loadPlayerScript(){
        loadResourceFile(this.apiUrl, 'js');
    }

    onYouTubeIframeAPIReady(){
        this.player = new YT.Player(this.target.id, {
            height: "390",
            width: "640",
            playsinline: 1,
            videoId: this.videoId,
            playerVars: {
                autoplay: 1,
                controls: 1,
                modestbranding: 1,
                cc_load_policy: 0,
                iv_load_policy: 3,
                mute: 1,
                rel: 0,
            },
            events: {
                'onReady': this.onPlayerReady.bind(this)
            }
        })
    }

    onPlayerReady(){
        this.poster.remove();
        this.play.remove();
    }

    onPlayClick(){
        this.loadPlayerScript();
        this.onYouTubeIframeAPIReady();
    }

    util__uniqid(prefix = "", random = false) {
        const sec = Date.now() * 1000 + Math.random() * 1000;
        const id = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
        return `${prefix}-${id}${random ? `-${Math.trunc(Math.random() * 100000000)}`:""}`;
    };
}

exports.YoutubeEmbed = YoutubeEmbed